module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-btn-beijing.f2a96f4a.png";